export const LOGIN_MODAL_STATE: string = 'LOGIN_MODAL_STATE'
export const CART_SIDEBAR_STATE: string = 'CART_SIDEBAR_STATE'
export const NAVIGATION_DRAWER_STATE: string = 'NAVIGATION_DRAWER_STATE'
export const NAVIGATION_SEARCH_STATE: string = 'NAVIGATION_SEARCH_STATE'

// only for dev
export const DEV_NAVIGATION_WITH_IMAGES: string = 'DEV_NAVIGATION_WITH_IMAGES'
export const DEV_LISTING_HIDE_REVIEW: string = 'DEV_LISTING_HIDE_REVIEW'
